export const EVENT_DATE = new Date("2026-10-03T20:00:00+02:00");
export const EVENT_DATE_LABEL = "Samedi 3 octobre · 2026";

export const NAV_LINKS = [
    { label: "Accueil", href: "#home" },
    { label: "Remerciements", href: "#remerciements" },
    { label: "Invitation", href: "#invitation" },
    { label: "Photos", href: "#photos" },
    { label: "Aftermovie", href: "#aftermovie" },
];

export const MARQUEE_ITEMS = [
    "Once Upon a Time in Hollywood",
];

export const INVITATION_HEADER = [
    "Monsieur et Madame Anton Cox",
    "vous prient d'assister à la soirée",
];

export const EVENING_STEPS = [
    {
        number: "01",
        time: "20H",
        title: "Le Cocktail",
        body: "Dès 20h, les invités sont conviés à franchir le tapis rouge et à profiter d'un cocktail avant le début de la cérémonie. Un premier moment pour se retrouver, échanger quelques mots et prendre place dans l'ambiance de la soirée.",
    },
    {
        number: "02",
        time: "21H",
        title: "Le Dîner & la Cérémonie",
        body: "À 21h, place au dîner et au grand rendez-vous de la soirée. Entre les différents prix remis au cours de la cérémonie, les surprises et les nombreux moments préparés pour l'occasion, le dîner sera ponctué de quelques instants inattendus et mémorables.",
    },
    {
        number: "03",
        time: "23H",
        title: "La Soirée",
        body: "À 23h, les lumières changent et le tapis rouge laisse place au dancefloor. Tous les acteurs de cette belle soirée sont invités à rejoindre la piste pour célébrer Lavinia et danser ensemble jusqu'au bout de la nuit.",
    },
];

export const EVENT_FACTS = [
    { label: "Date", value: "03 octobre 2026" },
    { label: "Heure", value: "20h" },
    { label: "Lieu", value: "Le Piesmont" },
    { label: "Adresse", value: "Allée des Grands Clos 8 · 1380 Lasne" },
    { label: "Dress Code", value: "Pour elle : robe longue · Pour lui : black tie" },
];

export const DRESS_LOOKS = [
    {
        number: "I",
        title: "Pour Elle",
        body: "Robe longue, allure de tapis rouge. Une silhouette qui mérite les flashs — rien de plus, rien de moins.",
    },
    {
        number: "II",
        title: "Pour Lui",
        body: "Black tie, nœud papillon. Le smoking est la règle ; l'élégance, la consigne.",
    },
    {
        number: "III",
        title: "La Touche d'Or",
        body: "Un détail doré quelque part sur soi — une boucle, un bouton de manchette, un talon. La nuit est une scène ; vous en êtes l'acteur.",
    },
];

export const DRESSCODE_IMAGES = [
    { url: "/images/dresscode/look-d.jpeg", caption: "Le duo — rouge et or" },
    { url: "/images/dresscode/look-c.jpeg", caption: "Main dans la main sous les palmiers" },
    { url: "/images/dresscode/look-b.jpeg", caption: "L'arrivée sous les flashs" },
    { url: "/images/dresscode/look-a.jpeg", caption: "L'oscar à la main" },
    { url: "/images/dresscode/look-1.webp", caption: "La robe longue — pleine lumière" },
    { url: "/images/dresscode/look-2.webp", caption: "Le black tie — version moderne" },
    { url: "/images/dresscode/look-4.webp", caption: "L'élégance blanche — allure de gala" },
    { url: "/images/dresscode/look-5.jpeg", caption: "Le smoking classique — intemporel" },
];

export const TEASER_POSTER = "/videos/teaser-poster.jpg";
